export default __webpack_public_path__ + "static/media/card_bg_2.cbebdccb.jpg";